module.exports = __webpack_public_path__ + "static/media/Barmag 6b.e118ce9a.jpg";